import { Link } from 'react-router-dom';
import PageNotFoundAsset from '../../assets/svg/404.svg';
import { Button } from '../../components/ui/button';

const PageNotFound = () => {
    return (
        <div className='flex flex-col justify-center items-center gap-4 h-[80vh] px-4 text-center'>
            {/* Image */}
            <img 
                src={PageNotFoundAsset} 
                alt='Page Not Found' 
                className='max-w-full h-auto md:max-w-md lg:max-w-lg'
            />
            
            {/* Main Message */}
            <p className='text-2xl md:text-3xl font-bold text-gray-900 dark:text-gray-100'>
                Oops! Page Not Found
            </p>
            
            {/* Sub Message */}
            <p className='text-base md:text-lg text-gray-600 dark:text-gray-300 text-center max-w-2xl'>
                Don't worry, even the best employees take a wrong turn sometimes! <br /> 
                🚀 Let's get you back on track.
            </p>
            
            {/* Back to Home Button */}
            <Link to={"/home"} className='mt-2'>
                <Button variant="brand">
                    Back To Home
                </Button>
            </Link>
            
            {/* Support Contact */}
            <p className='text-sm md:text-base text-gray-500 dark:text-gray-400 text-center mt-4'>
                If the issue persists, contact our support team <br />
                at <a 
                    href="mailto:support@hrbuddie.com?subject=Support Request&body=Hi Team, I need help with..." 
                    className='text-[#04B7B1] hover:text-[#04B7B1] dark:text-cyan-400 dark:hover:text-cyan-300 transition-colors duration-200'
                >
                    support@hrzyra.com
                </a>
            </p>
        </div>
    );
};

export default PageNotFound;